import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import { FormFieldCard } from 'core/components/validatedForm/FormFieldCard'
import TextField from 'core/components/validatedForm/TextField'
import PicklistField from 'core/components/validatedForm/DropdownField'
import Text from 'core/elements/Text'
import UnderlayNetworkTypesPicklist from './UnderlayNetworkTypesPicklist'
import { rangeLabelMap, rangeTooltipMap, rangePlaceholderMap } from './helpers'

const useStyles = makeStyles((theme: Theme) => ({
  cardBody: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  submitWarning: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
}))

interface ClusterBlueprintBasicConfigsProps {
  params: any
  getParamsUpdater: (field: string) => (value: any) => void
  currentBlueprintName: string
  hypervisorAuthorized: boolean
}

export default function ClusterBlueprintBasicConfigs({
  params,
  getParamsUpdater,
  currentBlueprintName,
  hypervisorAuthorized,
}: ClusterBlueprintBasicConfigsProps) {
  const classes = useStyles()

  return (
    <FormFieldCard title="Cluster Network Parameters" fullWidth>
      <div className={classes.cardBody}>
        <TextField
          id="name"
          label="Cluster Blueprint Name"
          onChange={getParamsUpdater('name')}
          value={params.name}
          disabled={!!currentBlueprintName}
          required
        />
        <TextField
          id="dnsDomainName"
          label="DNS Domain Name"
          onChange={getParamsUpdater('dnsDomainName')}
          value={params.dnsDomainName}
          info="Specify the DNS domain name for your organization. A newly created VM's FQDN will be <vm_name>.<dns_domain_name>"
          required
        />
        {/* As mentioned in tracker We can expose these in the future Commenting out - https://platform9.atlassian.net/browse/PCD-3968 */}
        {/* <ToggleSwitchField
          id="enableDvr"
          value={params.enableDvr}
          onChange={getParamsUpdater('enableDvr')}
          label="Enable Distributed Virtual Routing (DVR)"
          disabled={hypervisorAuthorized}
        />
        <ToggleSwitchField
          id="enableVirtualNetworking"
          value={params.enableVirtualNetworking}
          onChange={getParamsUpdater('enableVirtualNetworking')}
          label="Enable Virtual Networking"
          disabled={hypervisorAuthorized}
        /> */}
        {params.enableVirtualNetworking && (
          <>
            <PicklistField
              DropdownComponent={UnderlayNetworkTypesPicklist}
              id="segmentationTechnology"
              label="Segmentation Technology"
              value={params.segmentationTechnology}
              onChange={getParamsUpdater('segmentationTechnology')}
              networkingBackend="ovn"
              disabled={hypervisorAuthorized}
              required
            />
            <TextField
              id="segmentationRange"
              label={rangeLabelMap[params?.segmentationTechnology]}
              onChange={getParamsUpdater('segmentationRange')}
              value={params.segmentationRange}
              info={rangeTooltipMap[params?.segmentationTechnology]}
              placeholder={rangePlaceholderMap[params?.segmentationTechnology]}
              // validations={[cidrValidator]}
              // disabled={hypervisorAuthorized}
              required
            />
          </>
        )}
      </div>
    </FormFieldCard>
  )
}
